import { useCallback } from 'react'
import { LoginTypeEnum, setMaxSessionExtensionCount } from '@app-store'
import {
  MandatoryReloginManager as MandatoryReloginManagerBase,
  mandatorySessionExtensionSlotMs,
} from '@ecrm-session'
import { NAMESPACES } from '../utils/controlTypes'
import { environment } from '../utils/environment'
import { persist, useAppDispatch, useAppSelector } from '../utils/agent.store'
import { store } from '../utils/store'
import { performAgentDeskLogout } from './agentLogout'

const WARN_ACK_STORAGE_PREFIX = 'agentDesk.mandatoryReloginWarnAck:'

function MandatoryReloginManager() {
  const dispatch = useAppDispatch()
  const ctiCallActive = useAppSelector(
    (state) => state.awsCall?.incomingCall ?? false
  )
  const mandatoryPolicy =
    environment.mandatoryReloginAfterMinutes > 0
      ? {
          maxMinutes: environment.mandatoryReloginAfterMinutes,
          warnMinutes: environment.mandatoryReloginWarningMinutes,
        }
      : null

  const onMandatoryLogout = useCallback(() => {
    const t = store.getState().session.token
    void performAgentDeskLogout({
      dispatch,
      persist,
      token: t,
      loginType: LoginTypeEnum.MANDATORY_RELOGIN_LOGOUT,
      broadcastCrossTab: true,
    })
  }, [dispatch])

  const applyMaxSessionExtensionCount = useCallback(
    (count: number) => {
      dispatch(setMaxSessionExtensionCount(count))
    },
    [dispatch]
  )

  return (
    <MandatoryReloginManagerBase
      namespaces={{
        softTitle: NAMESPACES.MANDATORY_RELOGIN_SOFT_TITLE,
        softBody: NAMESPACES.MANDATORY_RELOGIN_SOFT_BODY,
        acknowledge: NAMESPACES.MANDATORY_RELOGIN_ACKNOWLEDGE,
        hardTitle: NAMESPACES.MANDATORY_RELOGIN_HARD_TITLE,
        hardBody: NAMESPACES.MANDATORY_RELOGIN_HARD_BODY,
        logoutButton: NAMESPACES.MANDATORY_RELOGIN_LOGOUT_BUTTON,
        extendSessionButton: NAMESPACES.MANDATORY_RELOGIN_EXTEND_SESSION,
        logoutNowButton: NAMESPACES.MANDATORY_RELOGIN_LOGOUT_NOW,
        closeWarningButton: NAMESPACES.MANDATORY_RELOGIN_CLOSE_WARNING,
      }}
      mandatoryPolicy={mandatoryPolicy}
      warnAckStoragePrefix={WARN_ACK_STORAGE_PREFIX}
      onMandatoryLogout={onMandatoryLogout}
      applyMaxSessionExtensionCount={applyMaxSessionExtensionCount}
      extensionSlotMs={mandatorySessionExtensionSlotMs(
        environment.mandatorySessionExtensionSlotMinutes
      )}
      maxMandatoryExtensions={environment.mandatorySessionMaxExtensions}
      ctiCallActive={ctiCallActive}
    />
  )
}

export default MandatoryReloginManager
